import { Subscription } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { Credentials } from '@shared/models/credentials.interface';
import { UserService } from '@core/services/user.service';
import { SettingService } from '@core/services/setting.service'
import * as toastr from "toastr";
import { version } from '../../../../../package.json'
import { ShowDiasFaltandoPeriodoVendasService } from '@core/services/show-dias-faltando-periodo-vendas.service';
import { CredentialsChangPassword } from '@shared/models/credentialsChangPassword';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss'],
  providers: [ShowDiasFaltandoPeriodoVendasService]
})
export class LoginFormComponent implements OnInit {

  loginForm: FormGroup;
  resetForm: FormGroup;
  resetFormPassword: FormGroup;
  errors: string[];
  subscription: Subscription;
  submitted = false;
  isRequesting = false;
  isRequestingRedefinePassword = false;
  isRedefine: boolean = false;
  isRedefinePassword: boolean = false;
  backendVersion: string;
  frontendVersion = version

  constructor(
    private userService: UserService,
    private router: Router,
    private formBuilder: FormBuilder,
    private settingService: SettingService,
    private showDiasFaltandoPeriodoVendasService: ShowDiasFaltandoPeriodoVendasService,) {
  }

  ngOnInit() {
    this.errors = [];
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]]
    });

    this.resetForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });

    this.resetFormPassword = this.formBuilder.group({
      passwordEmail: ['', [Validators.required]],
      newPassword: ['', [Validators.required]],
      confirmPassword: ['', [Validators.required]],
    });

    this.getBackVersion()
  }

  get fl() {
    return this.loginForm.controls;
  }

  get fr() {
    return this.resetForm.controls;
  }

  get frp(){
    return this.resetFormPassword.controls;
  }

  get flErrors() {
    return this.errors;
  }

  onSubmit() {
    this.errors = [];
    this.submitted = true;
    this.isRequesting = true;

    console.log('submimtted');

    if (this.loginForm.invalid) {
      this.isRequesting = false;
      return;
    }

    if (this.loginForm.valid) {

      let cred: Credentials = {
        email: this.fl.email.value,
        password: this.fl.password.value
      };

      this.userService.login(cred).pipe(first())
        .subscribe(
          data => this.getInfoUsuarioLogado(cred.email, cred.password),
          error => {
            this.errors.push('Log-on mal sucedido. Os detalhes informados não correspondem aos nossos registros, tente novamente.');
            this.submitted = false;
            this.isRequesting = false;
          });

    }
  }

  getInfoUsuarioLogado(token, token2){ //token por enquanto é o email
    this.userService.getUserLogado(token, token2).subscribe(
      resp => {
        console.log('user', resp)
        localStorage.setItem('user_logado', JSON.stringify(resp) );
        this.router.navigate(['']);
        this.showDiasFaltandoPeriodoVendasService.execute()
      },
      error => {
        console.log(error)
        this.errors.push('Log-on mal sucedido. Os detalhes informados não correspondem aos nossos registros, tente novamente.');
        this.submitted = false;
        this.isRequesting = false;
      }
    )
  }

  fnRedefine(act: boolean) {
    this.isRedefine = act;
    this.isRedefinePassword = false;
  }

  fnRedefinePassword(act: boolean){
    this.isRequesting = false;
    this.isRedefinePassword = act;
    this.isRequestingRedefinePassword = act;
  }

  requesting(act: boolean){
    this.isRequesting = act;
    this.isRedefine = act
    this.isRequestingRedefinePassword = act;
  }

  resetPassword() {
    this.errors = [];
    this.submitted = true;
    this.isRequesting = true;

    if (this.resetForm.invalid) {
      //this.submitted = false;
      this.isRequesting = false;
      return;
    }

    if (this.resetForm.valid) {

      let cred: Credentials = {
        email: this.fr.email.value,
        password: ''
      };

      this.userService.reset(cred).pipe(first())
        .subscribe(
          data => {
            //this.router.navigate(['/dashboard/home']);
            toastr.success("Email enviado com sucesso");
            this.submitted = false;
            this.isRequesting = false;

            //criar variaver que vai alimentar aqui o menu para colocar os campos de senha atual + senha nova + repetição
            this.fnRedefine(false);
            this.fnRedefinePassword(true);
          },
          error => {
            this.errors.push('');
            this.submitted = false;
            this.isRequesting = false;
          });

    }

  }

  changePassword() {

    console.log("Email", this.fr.email.value);
    this.errors = [];
    this.submitted = true;
    this.isRequesting = true;

    if (this.resetForm.invalid) {
      //this.submitted = false;
      this.isRequesting = false;
      return;
    }

    if(this.frp.passwordEmail.value == ""){
      toastr.error("Informe a senha enviada!");

      return;

    }else if(this.frp.newPassword.value == ""){
      toastr.error("Informe a nova senha!");

      return;

    }else if(this.frp.confirmPassword.value == ""){
      toastr.error("Confirme a nova senha!");

      return;
    }

    if (this.resetForm.valid) {

      let cred: CredentialsChangPassword = {
        emailPassword: this.frp.passwordEmail.value,
        newPassword: this.frp.newPassword.value,
        confirmPassword: this.frp.confirmPassword.value,
        email: this.fr.email.value
      };

      this.userService.changePassword(cred).pipe(first())
        .subscribe(
          data => {
            //this.router.navigate(['/dashboard/home']);
            toastr.success("Senha alterada com sucesso!");
            this.submitted = false;
            this.isRequesting = false;

            //limpando campos
            this.frp.passwordEmail.setValue('');
            this.frp.newPassword.setValue('');
            this.frp.confirmPassword.setValue('');

            this.fnRedefine(false);
            this.fnRedefinePassword(true);
            this.requesting(false);
          },
          error => {
            this.errors.push('');
            this.submitted = false;
            this.isRequesting = false;
          });

    }

  }

  createNewPassword(){
    if (this.resetForm.invalid) {
      //this.submitted = false;
      this.isRequesting = false;
      return;
    }

    if (this.resetForm.valid) {

      // após o retorno da requisição, coloco o campo para mostrar o login e senha 
      this.isRequestingRedefinePassword = false;
    }
  }

  getBackVersion(){
    this.settingService.getVersaoBack()
      .subscribe(
        data => {
         this.backendVersion = data._body;
        },
        error => {
          console.log('error', error)
        }
      );
  }

}
